import { useCallback, useState } from "react";
import { useToast } from "../components/ui/toast";
import { userApi } from "../services/userApi";
import type { UsageEvent } from "../types/usage";

interface UsageEventsState {
  data: UsageEvent[];
  isLoading: boolean;
  error: string | null;
}

export interface UseUserUsageResult {
  usageEvents: UsageEventsState;
  refreshUsageEvents: (startAt: number, endAt: number) => Promise<void>;
}

export const useUserUsage = (): UseUserUsageResult => {
  const { push } = useToast();
  const [usageEvents, setUsageEvents] = useState<UsageEventsState>({
    data: [],
    isLoading: false,
    error: null,
  });

  const refreshUsageEvents = useCallback(async (startAt: number, endAt: number) => {
    setUsageEvents({ data: [], isLoading: true, error: null });
    try {
      const events = await userApi.listUsageEvents({
        start_at: startAt,
        end_at: endAt,
        limit: 1000,
      });
      setUsageEvents({ data: events, isLoading: false, error: null });
    } catch (err: any) {
      const message = err?.message || "Failed to load usage events";
      setUsageEvents({ data: [], isLoading: false, error: message });
      push({
        title: "User",
        description: message,
        variant: "destructive",
        durationMs: 6000,
      });
    }
  }, [push]);

  return {
    usageEvents,
    refreshUsageEvents,
  };
};
